import { render, staticRenderFns } from "./BaseTitleSubtitle.vue?vue&type=template&id=9d22249c&"
import script from "./BaseTitleSubtitle.vue?vue&type=script&lang=js&"
export * from "./BaseTitleSubtitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/salesforce/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d22249c')) {
      api.createRecord('9d22249c', component.options)
    } else {
      api.reload('9d22249c', component.options)
    }
    module.hot.accept("./BaseTitleSubtitle.vue?vue&type=template&id=9d22249c&", function () {
      api.rerender('9d22249c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/BaseTitleSubtitle.vue"
export default component.exports